import { render, staticRenderFns } from "./Cats_stations.vue?vue&type=template&id=53945c55&scoped=true"
import script from "./Cats_stations.vue?vue&type=script&lang=js"
export * from "./Cats_stations.vue?vue&type=script&lang=js"
import style0 from "./Cats_stations.vue?vue&type=style&index=0&id=53945c55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53945c55",
  null
  
)

export default component.exports